import * as React from "react";
import { Box } from "@mui/material";
import { ParkingMapGrid } from "../components/parkingMapGrid";
import { ZoomPan } from "../components/zoomPan";
import { useParams } from 'react-router';


export default function Plano({ changeConBack, changeTitle }) {
  const espacioId = useParams().id;
  const [selected, setSelected] = React.useState([]);

  // Datos que se levantan desde la DB
  const rowCount = 10;
  const colCount = 20;
  const name = 'Cine 2';
  const slots = [
    { id: "A1", row: 0, col: 0, status: "free", label: "A1" },
    { id: "A2", row: 0, col: 1, status: "occupied", label: "A2" },
    { id: "A3", row: 0, col: 2, status: "free", label: "A3" },

    { id: "B1", row: 1, col: 0, status: "blocked", label: "B1" },
    { id: "B2", row: 1, col: 1, status: "free", label: "B2" },

    { id: "C3", row: 2, col: 2, status: "free", label: "C3" },

  ];

  React.useEffect(() => {
    changeTitle(name);
    changeConBack(true);
  }, [name]);

  return (
    <Box sx={{ p: 2, height: '100%' }}>
      <ZoomPan sx={{ width: "100%", height: '100%' }} minScale={0.6} maxScale={3}>
        {({ navigationEnabled }) => (
          <ParkingMapGrid
            name={name}
            rows={rowCount}
            cols={colCount}
            slots={slots}
            selectedIds={selected}
            onChangeSelected={setSelected}
            cellSize={46}
            // ✅ cuando navigationEnabled=true => estamos en navegación => selección OFF
            selectionEnabled={!navigationEnabled}
          />
        )}
      </ZoomPan>
    </Box>
  );
}
